import { http, unwrapData } from '@noor/api';
import { env } from '@noor/config';
import { deliveryReportSchema, type DeliveryReport } from '../model/schema';

export const deliveryReportApi = {
  async get(): Promise<DeliveryReport> {
    const raw = await http.get<unknown>('api/v1/merchant/delivery/reports', {
      baseURL: env.VITE_CORE_API_URL,
    });
    return deliveryReportSchema.parse(unwrapData(raw));
  },
};
